var _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGithub(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 62,
    viewBox: "0 0 60 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_4_47)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 14.1841V45.1311L30.2892 55L54 45.1311L54 14.1841L30.2891 7L6 14.1841Z",
    fill: "#204751"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71637 13.2252L5 13.4371V14.1841V45.1311V45.8042L5.62358 46.0576L29.9127 55.9264L30.2937 56.0813L30.6734 55.9232L54.3843 46.0543L55 45.7981V45.1311L55 14.1841V13.4422L54.29 13.2271L30.5791 6.04296L30.2926 5.95615L30.0055 6.04107L5.71637 13.2252Z",
    stroke: "#56A8BD",
    strokeOpacity: 0.62,
    strokeWidth: 2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_47)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.0004 15.6667C26.202 15.6686 22.5282 17.0139 19.6358 19.462C16.7435 21.9101 14.8212 25.3013 14.2127 29.0293C13.6043 32.7573 14.3493 36.5789 16.3145 39.8109C18.2798 43.0428 21.3371 45.4743 24.9399 46.6706C25.7348 46.8181 26.0341 46.3255 26.0341 45.9067C26.0341 45.4878 26.0182 44.2733 26.0129 42.9456C21.5619 43.9072 20.6213 41.0673 20.6213 41.0673C19.8954 39.2232 18.8462 38.7385 18.8462 38.7385C17.3943 37.7533 18.9548 37.7717 18.9548 37.7717C20.5631 37.885 21.4082 39.4129 21.4082 39.4129C22.8336 41.8444 25.1519 41.1411 26.0633 40.7301C26.2064 39.7001 26.6223 38.9993 27.0807 38.6015C23.5251 38.2011 19.7894 36.8365 19.7894 30.7406C19.7674 29.1596 20.3574 27.6307 21.4374 26.4702C21.2731 26.0698 20.7247 24.4523 21.5937 22.2552C21.5937 22.2552 22.937 21.8285 25.9944 23.8859C28.6169 23.1728 31.3838 23.1728 34.0063 23.8859C37.0611 21.8285 38.4018 22.2552 38.4018 22.2552C39.2734 24.447 38.725 26.0645 38.5607 26.4702C39.6441 27.6309 40.2354 29.1625 40.2113 30.7458C40.2113 36.8549 36.4677 38.2011 32.9068 38.5936C33.4791 39.0889 33.9904 40.0557 33.9904 41.5415C33.9904 43.6701 33.9719 45.3824 33.9719 45.9067C33.9719 46.3308 34.2607 46.826 35.0714 46.6706C38.6746 45.4742 41.7323 43.0423 43.6975 39.8098C45.6627 36.5773 46.4073 32.7551 45.7982 29.0267C45.189 25.2984 43.2658 21.9071 40.3725 19.4595C37.4792 17.0118 33.8045 15.6674 30.0057 15.6667H30.0004Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0593 38.5093C20.0248 38.5884 19.8977 38.6121 19.7943 38.5568C19.691 38.5014 19.6142 38.3987 19.6513 38.317C19.6884 38.2354 19.8129 38.2143 19.9162 38.2696C20.0195 38.3249 20.099 38.4303 20.0593 38.5093Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7084 39.2285C20.6535 39.256 20.5908 39.2637 20.5308 39.2502C20.4709 39.2368 20.4175 39.203 20.3799 39.1547C20.2766 39.0441 20.2553 38.8913 20.3348 38.8228C20.4143 38.7543 20.5574 38.7859 20.6607 38.8966C20.764 39.0072 20.7879 39.16 20.7084 39.2285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.339 40.1426C21.2409 40.2111 21.074 40.1426 20.9813 40.0057C20.9556 39.9811 20.9353 39.9516 20.9213 39.919C20.9074 39.8864 20.9002 39.8514 20.9002 39.816C20.9002 39.7806 20.9074 39.7455 20.9213 39.7129C20.9353 39.6803 20.9556 39.6509 20.9813 39.6263C21.0793 39.5605 21.2462 39.6263 21.339 39.7607C21.4317 39.895 21.4344 40.0742 21.339 40.1426Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1947 41.0278C22.1073 41.1252 21.9298 41.0989 21.7841 40.9672C21.6384 40.8355 21.6039 40.6563 21.6913 40.5615C21.7788 40.4667 21.9563 40.493 22.1073 40.6221C22.2583 40.7512 22.2875 40.9329 22.1947 41.0278Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3949 41.5441C23.3551 41.6679 23.175 41.7233 22.9948 41.6706C22.8146 41.6179 22.6954 41.4704 22.7299 41.3439C22.7643 41.2175 22.9471 41.1595 23.1299 41.2175C23.3127 41.2754 23.4293 41.415 23.3949 41.5441Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7038 41.6337C24.7038 41.7628 24.5554 41.8734 24.3647 41.8761C24.1739 41.8787 24.0176 41.7733 24.0176 41.6442C24.0176 41.5152 24.1659 41.4045 24.3567 41.4019C24.5475 41.3992 24.7038 41.502 24.7038 41.6337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9225 41.4309C25.9464 41.5599 25.8139 41.6943 25.6232 41.7259C25.4324 41.7575 25.2655 41.6811 25.2416 41.5547C25.2178 41.4282 25.3556 41.2912 25.541 41.257C25.7265 41.2227 25.8987 41.3018 25.9225 41.4309Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4_47",
    x: 0,
    y: 0.912292,
    width: 60,
    height: 60.2502,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_4_47"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_47"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(14 15)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.a3cb28e8b9d596157ca7162c28971018.svg";
export { ForwardRef as ReactComponent };